import { useCustomSuspenseQuery } from "@/hooks/use-graphql-client";

import { Voucher_EditPage_Query } from "../schema/voucher";

type Props = {
	hotelID: string;
	voucherID: string;
};

export const useVoucherQuery = ({ hotelID, voucherID }: Props) => {
	const { data } = useCustomSuspenseQuery(Voucher_EditPage_Query, {
		variables: { hotelID, voucherID },
	});

	return data;
};
